<template>
  <div class="card-body">
    <div class="row">

      <div class="form-group col-sm-2">

        <label>Cd Flag Ws</label>

        <b-form-group :invalid-feedback="violations['cdFlagWs']" :state="!violations['']">

          <b-form-input v-model="ssv2314CadtrFlagWs.cdFlagWs" type="text" placeholder="" :required="true" :readonly="false"></b-form-input>

        </b-form-group>
      </div>

      <div class="form-group col-sm-2">

        <label>Ds Flag Ws</label>

        <b-form-group :invalid-feedback="violations['dsFlagWs']" :state="!violations['']">

          <b-form-input v-model="ssv2314CadtrFlagWs.dsFlagWs" type="text" placeholder="" :required="true" :readonly="false"></b-form-input>

        </b-form-group>
      </div>

      <div class="form-group col-sm-2">

        <label>Dt Solct Cadtr</label>

        <b-form-group :invalid-feedback="violations['dtSolctCadtr']" :state="!violations['']">

          <date-picker v-model="ssv2314CadtrFlagWs.dtSolctCadtr" type="date" value-type="format" lang="pt-br" format="DD/MM/YYYY" placeholder="" :required="false" :readonly="false"></date-picker>

        </b-form-group>
      </div>

      <div class="form-group col-sm-2">

        <label>Nm Flag Ws</label>

        <b-form-group :invalid-feedback="violations['nmFlagWs']" :state="!violations['']">

          <b-form-input v-model="ssv2314CadtrFlagWs.nmFlagWs" type="text" placeholder="" :required="true" :readonly="false"></b-form-input>

        </b-form-group>
      </div>

    </div>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";
  import store from "@/store";
  
  import { 
  	
      } from "@/store/actions.type";
      
  export default {
    props: ['ssv2314CadtrFlagWs', 'violations'],
    computed: {
  	    ...mapGetters([
  	         
  	         ]),
    },
    methods:{
        
    },
    mounted(){
      
    }
  }
</script>